// extracted by mini-css-extract-plugin
export var blockTitle = "course-module--block-title--80235";
export var col = "course-module--col--b08e1";
export var course = "course-module--course--35161";